// extracted by mini-css-extract-plugin
module.exports = {"linkCard":"LinkCard-module--linkCard--2G6Mc","linkText":"LinkCard-module--linkText--3qLi5"};